module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapFM"
  }, [_vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("May 15, 1963 "), _c('br'), _vm._v("Cape Canaveral")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-1"
  }, [_vm._v("They woke me up at three in the morning, in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had been up late the night before, hitting the sack not much before eleven o’clock in Hangar S, the astronaut headquarters at the Cape. The hangar had been remodeled inside to accommodate our various types of training apparatus, a pressure chamber, living quarters and a dining room, a medical suite, a ready room, and everything else we needed to prepare for a mission. It was also here that the National Aeronautics and Space Administration (NASA) had offices and where our spacecraft were constantly worked on by engineers and technicians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I showered, then enjoyed a “going away” breakfast of fresh-squeezed orange juice, filet mignon, scrambled eggs, toast, grape jelly, and coffee, with some of the key people on the team, including the flight surgeon and a few fellow astronauts who, through their good-natured ribbing, were determined to see that I stayed loose."), _c('a', {
    attrs: {
      "id": "i133"
    }
  }), _c('a', {
    attrs: {
      "id": "i207"
    }
  }), _c('a', {
    attrs: {
      "id": "i399"
    }
  }), _c('a', {
    attrs: {
      "id": "i776"
    }
  }), _c('a', {
    attrs: {
      "id": "i872"
    }
  }), _c('a', {
    attrs: {
      "id": "i1049"
    }
  }), _c('a', {
    attrs: {
      "id": "i1290"
    }
  }), _c('a', {
    attrs: {
      "id": "i1769"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From there, I went down the hall to the suiting-up room—a sterile space off-limits to bugs, dirt, debris, and anything else we didn’t want to take along into space. Everyone working in here was dressed in a white smock and white hat and wore disposable paper covers over their footwear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stripped, and a medical technician glued a half-dozen medical sensors to various spots on my body that he’d first sandpapered and scrubbed with alcohol. I donned long underwear and was helped into my bulky flight pressure suit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took the seven-mile trip to pad 14 in the back of a NASA van.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I much preferred the way I had arrived at the pad for final “hot tests” of all systems several days earlier: at the wheel of my new 300-horsepower blue Corvette, which I had purchased—the same way other astronauts purchased their ’Vets—at a 50 percent discount from General Motors through its Brass Hat program for employees and a limited number of VIPs. That day I had successfully lobbied my NASA bosses to let me drive myself to the pad on the promise that I’d be careful. I hadn’t even bothered to ask this morning, knowing what the answer would be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My rocket awaited me: Atlas booster number 130D, more than ten stories tall. It stood in the pitch dark like a lone sentry, eerily bathed in columns of white light thrown skyward by huge spotlights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first time I had seen an Atlas launch was three years earlier, only a few months after seven of us had been selected for "), _c('a', {
    attrs: {
      "id": "i1281"
    }
  }), _vm._v("Project Mercury as America’s first astronauts. They took us down to the Cape for a launch. We stood as a group outside in the humid night—the "), _c('a', {
    attrs: {
      "id": "i1074"
    }
  }), _vm._v("“Mercury Seven,” as we became known—flat-topped fighter jocks in short-sleeved shirts, buoyant and more than a tad cocky, as all good fighter pilots must be. We came to be referred to on in-house memos "), _c('a', {
    attrs: {
      "id": "i1079"
    }
  }), _vm._v("as CCGGSSS, as our names were always listed in alphabetical order: "), _c('a', {
    attrs: {
      "id": "i217"
    }
  }), _vm._v("Carpenter, Cooper, "), _c('a', {
    attrs: {
      "id": "i805"
    }
  }), _vm._v("Glenn, "), _c('a', {
    attrs: {
      "id": "i848"
    }
  }), _vm._v("Grissom, "), _c('a', {
    attrs: {
      "id": "i1435"
    }
  }), _vm._v("Schirra, "), _c('a', {
    attrs: {
      "id": "i1470"
    }
  }), _vm._v("Shepard, "), _c('a', {
    attrs: {
      "id": "i1512"
    }
  }), _vm._v("Slayton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were there to see a test of the Atlas, the newly built"), _c('a', {
    attrs: {
      "id": "i134"
    }
  }), _c('a', {
    attrs: {
      "id": "i395"
    }
  }), _c('a', {
    attrs: {
      "id": "i732"
    }
  }), _c('a', {
    attrs: {
      "id": "i890"
    }
  }), _c('a', {
    attrs: {
      "id": "i1125"
    }
  }), _c('a', {
    attrs: {
      "id": "i1291"
    }
  }), _c('a', {
    attrs: {
      "id": "i1298"
    }
  }), _c('a', {
    attrs: {
      "id": "i1390"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-3"
    }
  }), _vm._v(" rocket that was expected to carry us into orbit in the years to come. We watched the huge rocket rise slowly off the pad on three thick columns of flame. It was a thunderous start, and the ground rumbled beneath our feet. The rocket flew straight up for forty or fifty seconds and was almost directly overhead as it slowly began to nose over on its long arcing flight toward the horizon. Several hundred VIPs were in attendance, including many congressmen and several committee chairmen who were instrumental in providing funding for the space program. We all stood there, craning our necks to keep our eyes on the magnificent silver bird, when suddenly the sky erupted in a tremendous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kaboom!")]), _vm._v(" and the rocket blew up in a jillion flaming pieces. While some spectators ducked instinctively, the burning debris would be carried by the rocket’s momentum out over the ocean and drop into the drink several miles offshore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We looked at each other. “That’s our ride?” someone deadpanned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two months later there had been another cataclysmic failure, and in the months that followed, more failed attempts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late 1960 NASA put on another public show designed to prove that the Mercury spacecraft and the smaller Redstone rocket, which would be used for two planned suborbital flights, were ready for upcoming manned missions. These flights would not go high or fast enough to reach orbit but would simply slingshot the spacecraft one hundred miles high, where space officially begins—some fifty miles above the Earth’s atmosphere—and downrange three hundred miles at five thousand miles per hour for an ocean landing near Bermuda. For the event, NASA brought the seven of us back, along with hundreds of VIPs. This time, as the flames burst from the rocket, it lifted off only two inches before the engines mysteriously cut off and the rocket settled back onto the pad. All was quiet. However, the signal for liftoff had already been sent to the automatic sequencer. About sixty seconds later—as called for by the flight"), _c('a', {
    attrs: {
      "id": "i24"
    }
  }), _c('a', {
    attrs: {
      "id": "i135"
    }
  }), _c('a', {
    attrs: {
      "id": "i193"
    }
  }), _c('a', {
    attrs: {
      "id": "i222"
    }
  }), _c('a', {
    attrs: {
      "id": "i357"
    }
  }), _c('a', {
    attrs: {
      "id": "i411"
    }
  }), _c('a', {
    attrs: {
      "id": "i416"
    }
  }), _c('a', {
    attrs: {
      "id": "i577"
    }
  }), _c('a', {
    attrs: {
      "id": "i735"
    }
  }), _c('a', {
    attrs: {
      "id": "i822"
    }
  }), _c('a', {
    attrs: {
      "id": "i853"
    }
  }), _c('a', {
    attrs: {
      "id": "i1043"
    }
  }), _c('a', {
    attrs: {
      "id": "i1197"
    }
  }), _c('a', {
    attrs: {
      "id": "i1299"
    }
  }), _c('a', {
    attrs: {
      "id": "i1442"
    }
  }), _c('a', {
    attrs: {
      "id": "i1475"
    }
  }), _c('a', {
    attrs: {
      "id": "i1521"
    }
  }), _c('a', {
    attrs: {
      "id": "i1534"
    }
  }), _c('a', {
    attrs: {
      "id": "i1606"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-4"
    }
  }), _vm._v(" plan—the spacecraft’s escape tower, designed to pull the capsule and its occupant to safety in the event of a problem in the first minute after liftoff, separated from the spacecraft and shot into the sky like a spear. As the crowd silently watched the only thing moving out there that day, the escape tower went up about four thousand feet, then came back down, driving itself into the ground about a hundred yards away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for the Atlas, before John "), _c('a', {
    attrs: {
      "id": "i806"
    }
  }), _vm._v("Glenn’s orbital mission in 1962—the first manned mission to use the powerful new rocket—there had been a total of thirteen blowups, some on the launch pad and others as the Atlas climbed into the sky. "), _c('a', {
    attrs: {
      "id": "i1632"
    }
  }), _vm._v("Test pilots understood the nature of new technologies: going up in hurtling pieces of untested machinery and putting our hides on the line. We knew about hanging it over the edge and pushing back the envelope, then hauling it back in and doing it again tomorrow. When the time came, each of us would take his turn sitting atop the same type of rocket we’d seen blown to smithereens before our eyes. We did so not because we were suicidal or crazed but because we were pilots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early on in the space program there had been quite a debate over whether the manned launches should be covered on live "), _c('a', {
    attrs: {
      "id": "i1617"
    }
  }), _vm._v("television or a taped and edited version offered to the public later. Live TV would reveal anything and everything that went wrong; in the event of a tragic failure, public sentiment could turn against the program. I suppose we could have tried to do what the Soviets did—hide our failures and trumpet our successes—but could a free country really do that? We were the representatives of an open society, and we would take our chances in full view of the world—on live television.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up the gantry elevator I went on launch morning, carrying the suitcaselike portable cooler that kept me supplied with oxygen until I could be connected to the spacecraft’s system. At the top I was greeted by Guenter "), _c('a', {
    attrs: {
      "id": "i1745"
    }
  }), _vm._v("Wendt, who in his “clean room"), _c('a', {
    attrs: {
      "id": "i1076"
    }
  }), _vm._v("” attire of white overalls and white sandwich hat looked like the "), _c('a', {
    attrs: {
      "id": "i415"
    }
  }), _c('a', {
    attrs: {
      "id": "i437"
    }
  }), _c('a', {
    attrs: {
      "id": "i740"
    }
  }), _c('a', {
    attrs: {
      "id": "i1161"
    }
  }), _c('a', {
    attrs: {
      "id": "i1224"
    }
  }), _c('a', {
    attrs: {
      "id": "i1264"
    }
  }), _c('a', {
    attrs: {
      "id": "i1550"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" neighborhood ice cream man but who was one of the brilliant "), _c('a', {
    attrs: {
      "id": "i779"
    }
  }), _vm._v("German rocket scientists helping the United States in the space race with the Russians, who also had German rocket men assisting them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saluted "), _c('a', {
    attrs: {
      "id": "i1746"
    }
  }), _vm._v("Wendt, keeping up an old private joke. “Private Fifth Class Cooper reporting for duty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He saluted back. “Private Fifth Class Wendt standing by.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We had been “demoted” following a practical joke pulled a couple of years earlier on a TV film crew. We had all been working around the clock getting ready for the first suborbital mission when, about three days before launch, the bosses decided to let a news crew film “launch day in the life of an astronaut.” I was selected to be the model, and they followed me everywhere, even filming me getting into long underwear after the sensors were attached to various parts of my anatomy. All of us considered the contrived show a big waste of time, but NASA was always looking to curry favor with the media. We had gone out to the pad in the transfer van, and when we got there Guenter met us. As we arrived at the bottom of the elevator, the door opened and everyone started forward. I suddenly grabbed the door of the elevator and hollered, “No! No! I won’t go!” Guenter, meanwhile, was trying desperately to drag me into the elevator. The NASA public relations people and the media were not amused. One writer suggested that Guenter and I should be busted to “Private Fifth Class,” and it stuck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I sat atop the rocket, at some point during the final hour of the nearly three-hour preflight routine, after I had done all my work and we were waiting for technicians handling radar and other tracking devices to do their final calibrations and get up to speed, I felt myself begin to nod off. They had gotten me up "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so")]), _vm._v(" early. Knowing how busy I would soon be, it seemed like an ideal opportunity to grab a nap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, sitting atop the fully fueled rocket, with no place to go for the time being, I fell fast asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Gordo!”")]), _c('a', {
    attrs: {
      "id": "i169"
    }
  }), _c('a', {
    attrs: {
      "id": "i198"
    }
  }), _c('a', {
    attrs: {
      "id": "i312"
    }
  }), _c('a', {
    attrs: {
      "id": "i381"
    }
  }), _c('a', {
    attrs: {
      "id": "i417"
    }
  }), _c('a', {
    attrs: {
      "id": "i429"
    }
  }), _c('a', {
    attrs: {
      "id": "i1134"
    }
  }), _c('a', {
    attrs: {
      "id": "i1282"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came awake instantly, immediately aware of my situation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh-huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hate to disturb you, old buddy,” said Wally "), _c('a', {
    attrs: {
      "id": "i1436"
    }
  }), _vm._v("Schirra, serving as capsule communicator (CapCom) for my launch, “but we’ve got a launch to do here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s do it. Ready when you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the last of the Mercury astronauts to get a space shot—I like to think they were saving me all along for the last, the longest and best mission—I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" ready …")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e671ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/FM.vue
// module id = 69
// module chunks = 0